export const InspectionItems = (props) => {

    return props.data && (

        <table className="table table-bordered table-sm table-hover">
            <thead>
                <tr>
                    <th>#</th>
                    <th nowrap="true">Item</th>
                    <th nowrap="true">Result</th>
                </tr>
            </thead>
            <tbody>
                {props.data.map((task, i) => (
                    <tr key={`inspection-item-${i}`}>
                        <td nowrap="true">{i + 1}</td>
                        <td nowrap="true">{task.title}</td>
                        <td nowrap="true">
                            {Object.hasOwn(task, 'checkCompleteStatus') && task.checkCompleteStatus === 'passed' && task.isCompleted &&
                                <span className="badge bg-success">
                                    <i title="Passed" className="fas fa-lg fa-fw fa-check" />
                                </span>
                            }

                            {Object.hasOwn(task, 'checkCompleteStatus') && task.checkCompleteStatus === 'failed' && task.isCompleted &&
                                <span className="badge bg-danger">
                                    <i title="Failed" className="fas fa-lg fa-fw fa-x" />
                                </span>
                            }

                            {((Object.hasOwn(task, 'checkCompleteStatus') && task.checkCompleteStatus === 'na' && task.isCompleted) || !task.isCompleted) &&
                                <span className="badge bg-default">
                                    <i title="Not Checked or N/A" className="fas fa-lg fa-fw fa-expand text-black-900" />
                                </span>
                            }
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}